import { createStore } from './store';

export interface ToastAction {
  label: string;
  onPress(): void;
}

export interface ToastData {
  id: number;
  message: string;
  action?: ToastAction;
}

export const toastStore = createStore<ToastData | null>(null);
let seq = 0;

/** Shows a short message, optionally with one action (Undo). A new toast replaces the current one. */
export function showToast(t: { message: string; action?: ToastAction }): void {
  toastStore.set({ id: ++seq, ...t });
}

export function dismissToast(): void {
  toastStore.set(null);
}
